import styled from "styled-components";
import colors from "../../../../../../../../../styles/colorPalette";

export const Wrapper = styled.thead`
  position: sticky;
  padding: 0px 64px 0px 20px;
  text-align: center;
  height: 50px;
  background: ${colors.gray2};
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  padding: 0px 64px 0px 20px;
  text-align: center;
  height: 50px;
  background: ${colors.gray2};
`;

export const ItemLeft = styled.div`
  display: flex;
  position: sticky;
  align-items: center;
  justify-content: left;
  text-align: center;
  font-family: "OpenSansRegular";
  font-size: 18px;
  font-weight: 400;
  width: 300px;
  height: 100%;
  color: ${colors.gray4};
`;

export const ItemRight = styled.div`
  display: flex;
  position: sticky;
  align-items: center;
  justify-content: right;
  text-align: center;
  font-family: "OpenSansRegular";
  font-size: 18px;
  font-weight: 400;
  width: 300px;
  height: 100%;
  color: ${colors.gray4};
`;
